var map = {
	"./Produktion-Still.jpg": 8982,
	"./Technologie-Still.jpg": 7521,
	"./Totale-Still.jpg": 437,
	"./empty_page.png": 5709,
	"./locations/Standorte_final.jpg": 6251,
	"./locations/Weltkugel.jpg": 8481,
	"./locations/Weltkugel_alt.jpg": 8859,
	"./products/Products_E-Mobility_01e_Scene.jpg": 3443,
	"./products/Products_Getriebebauteile_03b_Scene.jpg": 1777,
	"./products/Products_Karosserie_Fahrw_Lenk_01d_Scene.jpg": 7360,
	"./products/Products_Motor_u_Antriebskomponenten_01f_Scene.jpg": 2418,
	"./sustainability/Sprout_2021.png": 4225,
	"./sustainability/Sprout_2023.png": 4597,
	"./sustainability/Sprout_2025.png": 25,
	"./sustainability/Sprout_2030.png": 2428,
	"./sustainability/Sprout_2039.png": 5523,
	"./sustainability/Technology_Sustainabilty_05a_V2.jpg": 7157,
	"./sustainability/Technology_Sustainabilty_10a_V3_Scene_Finish_01c_bg.jpg": 2481,
	"./technology/Competence_Simulations_01a.jpg": 3862,
	"./technology/Competence_Simulations_BG_01a.jpg": 3321,
	"./technology/Technology_ASE.jpg": 7280,
	"./technology/Technology_ASE_NEW.jpg": 4903,
	"./technology/Technology_ASE_old.jpg": 5893,
	"./technology/Technology_Die-Casting_07b.jpg": 9150,
	"./technology/Technology_Engineering_2a.jpg": 9632,
	"./technology/Technology_Gravity-Die-Casting_03e.jpg": 4667,
	"./technology/Technology_Machining_a_Assembling_03c_V2.jpg": 1297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3746;